/**
 * useBrowserLogger
 *
 * Amacı:
 * - Sayfa görünürlüğü (show/hide) ve pencere odak (focus/blur) değişimlerini dinleyip loglamak.
 * - Olaylar, verilen assetId ile ilişkilendirilerek `LogBrowserService` aracılığıyla kaydedilir.
 *
 * Parametreler:
 * - assetId: string | number — Log kayıtları için içerik/oturum kimliği.
 *
 * Loglanan Olaylar (eventType):
 * - 'show'  — Sekme görünür hale geldiğinde (Page Visibility API)
 * - 'hide'  — Sekme gizlendiğinde (başka sekmeye/geçişe odaklandığında vb.)
 * - 'focus' — Pencere/sekme odak kazandığında
 * - 'blur'  — Pencere/sekme odak kaybettiğinde
 *
 * Davranış ve Kenar Durumları:
 * - Hook mount olduğunda event listener'lar eklenir; unmount olduğunda temizlenir.
 * - assetId değiştiğinde, dinleyiciler güncel `log` fonksiyonunu kullanır.
 * - Page Visibility API için tarayıcı vendor önekleri (ms/webkit) desteklenir; gerekirse fallback kullanılır.
 * - SSR ortamında kullanılacaksa document/window korumaları eklenmelidir (bu hook tarayıcıda çağrılmalı).
 *
 * Kısa Kullanım Örneği:
 *
 * function PlayerPage({ assetId }) {
 *   useBrowserLogger(assetId);
 *   return <Player />;
 * }
 */

import { useEffect, useCallback } from "react";
import LogService from "../../service/log/LogService";
// import {logEventBus} from "./inactivity/logEventBus";

const service = new LogService('logBrowser');

export const useBrowserLogger = (assetId) => {
    const log = useCallback((eventType) => {
        service.create(
            {
                eventType,
                assetId,
                // metadata: JSON.stringify({
                //     visibilityState: document.visibilityState,
                // }),
            },
        );

        // Etkinliği logEventBus ile yayınla
        // logEventBus.emit({ type: eventType, timestamp: Date.now() });
    }, [assetId]);


    useEffect(() => {
        const { hidden, visibilityChange } = pageVisibilityApi();

        const onVisibilityChange = () => {
            const state = document[hidden] ? "hide" : "show";
            log(state);
        };

        const onFocus = () => log("focus");
        const onBlur = () => log("blur");

        document.addEventListener(visibilityChange, onVisibilityChange);
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);

        return () => {
            document.removeEventListener(visibilityChange, onVisibilityChange);
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, [assetId, log]);
};

// yardımcı fonksiyon
const pageVisibilityApi = () => {
    if (typeof document.hidden !== "undefined") {
        return { hidden: "hidden", visibilityChange: "visibilitychange" };
    } else if (typeof document.msHidden !== "undefined") {
        return { hidden: "msHidden", visibilityChange: "msvisibilitychange" };
    } else if (typeof document.webkitHidden !== "undefined") {
        return { hidden: "webkitHidden", visibilityChange: "webkitvisibilitychange" };
    }
    return { hidden: "hidden", visibilityChange: "visibilitychange" }; // fallback
};
